import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import { Root } from './TabPanel.styles'

/**
 * The TabPanel's component.
 */
const TabPanel = props => {
  const { ariaLabel, children, id, index, value } = props

  return (
    <Root id={id} hidden={value !== index} role="tabpanel" aria-labelledby={ariaLabel}>
      {value === index && <Box>{children}</Box>}
    </Root>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  id: PropTypes.any.isRequired,
  index: PropTypes.any.isRequired,
  ariaLabel: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
}

export default TabPanel
